var DeliveryAddress = (function (CheckoutApiModel) {
	return CheckoutApiModel.extend({
		idAttribute: 'ID',

		getAuthComment: function () {
			return this.get('AuthComment');
		},

		cancelSignature: function () {
			return this.applySignature(null);
		},

		applySignature: function (val) {
			this.set({
				AuthToLeave: !!val,
				AuthComment: val
			});
			return this._applyAuth();
		},

		isActive: function () {
			return this._isActive;
		},

		setActive: function (isActive) {
			this._isActive = isActive;
		},

		isValid: function () {
			return Boolean(this.get('ID'));
		},

		setData: function (data) {
			this.set(data);
		},

        _applyAuth: function () {
            window.app && app.event && app.event.chooseSignatureDelivery();
			return this._api.setAuthToLeave({
				authToLeave: this.get('AuthToLeave'),
				authComment: this.get('AuthComment'),
				deliveryAddressID: this.get('ID')
			});
		},

        setDeliveryOption: function (deliveryOption) {
            window.app && app.event && app.event.chooseDeliveryOption(deliveryOption);
			return this._api.setDeliveryOption({
				deliveryOption: deliveryOption,
				deliveryAddressID: this.get('ID'),
				imageSize: 200
			}).done(this._updateCheckout);
		}
	});
})(CheckoutApiModel);
